import api from '@/api';
import moment from 'moment';

const state = {
  member: null,
  timeEntries: [],
  totalHours: null,
  availableHours: null,
  productivity: null,
};

const actions = {
  async getTimeEntries({ commit }, payload) {
    commit('member', payload.member);
    const response = await api.post('Availability', {
      MemberId: payload.member,
      StartDate: payload.startDate,
      EndDate: payload.endDate,
    });
    commit('availabilityReportData', response.data);
  },

  async exportToExcel({ state, rootGetters }) {
    const member = rootGetters['members/getMemberFormattedNameById'](state.member);
    const response = await api.post('Reports/ExportAvailabilityReportToExcel', {
      AvailableHours: state.availableHours,
      TotalHours: state.totalHours,
      Productivity: state.productivity,
      Member: member,
      TimeEntries: state.timeEntries,
    }, { responseType: 'blob' });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Availability_${member}_${moment().format('YYYY-MM-DD')}.xlsx`);
    document.body.appendChild(link);
    link.click();
  },
};

const mutations = {
  availabilityReportData(state, payload) {
    state.timeEntries = payload.timeEntries;
    state.totalHours = payload.totalHours;
    state.availableHours = payload.availableHours;
    state.productivity = payload.productivity;
  },
  member(state, payload) {
    state.member = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
